export enum ShapeTypes {
    RECTANGLE = 'RECTANGLE',
    ELLIPSE = 'ELLIPSE',
    CUSTOM = 'CUSTOM',
}
